import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Typography, Card, Tag, Button, Tooltip, message } from 'antd';
import { DollarOutlined, ClockCircleOutlined, StarFilled, CheckCircleTwoTone } from '@ant-design/icons';
import styled, { keyframes } from 'styled-components';
import { API_BASE_URL } from '../../../utils/BaseUrl';
import Swal from 'sweetalert2';

const { Title, Paragraph } = Typography;

const statusColors = {
  Active: 'green',
  Inactive: 'volcano',
  Pending: 'gold',
  default: 'blue',
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(30px);}
  to { opacity: 1; transform: none;}
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
  margin-top: 32px;
  animation: ${fadeIn} 0.7s cubic-bezier(.4,0,.2,1);
`;

const StyledCard = styled(Card)`
  border-radius: 16px !important;
  box-shadow: 0 4px 18px rgba(241,86,55,0.13);
  border: none;
  transition: box-shadow 0.22s, transform 0.18s;
  background: linear-gradient(135deg, #fff7f3 70%, #fff 100%);
  min-height: 340px;
  max-width: 320px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  &:hover {
    box-shadow: 0 10px 32px rgba(241,86,55,0.18);
    transform: translateY(-6px) scale(1.03);
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Price = styled.div`
  color: #F15637;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const FeatureList = styled.ul`
  margin: 0 0 10px 0;
  padding-left: 0;
  color: #444;
  font-size: 0.98rem;
  line-height: 1.5;
  min-height: 48px;
  list-style: none;
  & > li {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

const PopularTag = styled(Tag)`
  background: linear-gradient(90deg, #ffb347 0%, #ffcc33 100%);
  color: #fff;
  font-weight: bold;
  border: none;
  margin-left: 8px;
  font-size: 1rem;
  box-shadow: 0 2px 8px #ffe08280;
`;

const StatusTag = styled(Tag)`
  position: absolute;
  top: 18px;
  right: 18px;
  font-weight: 600;
  font-size: 1rem;
  z-index: 2;
`;

const CoverImg = styled.img`
  width: 100%;
  height: 110px;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
  background: #f5f5f5;
  margin-bottom: 8px;
  box-shadow: 0 2px 10px #f1563722;
`;

const RegisterBtn = styled(Button)`
  background: linear-gradient(90deg, #f15637 60%, #ffb347 100%);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  padding: 0 18px;
  height: 36px;
  margin-top: 10px;
  box-shadow: 0 2px 8px #f1563733;
  transition: background 0.18s;
  &:hover, &:focus {
    background: linear-gradient(90deg, #ffb347 0%, #f15637 100%);
    color: #fff;
  }
`;

const PackageList = () => {
  const [packages, setPackages] = useState([]);
  const [loadingId, setLoadingId] = useState(null);
  

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/OwnerPakage`)
      .then(response => {
        setPackages(response.data);
      })
      .catch(error => {
        console.error('Lỗi khi load gói chủ phòng:', error);
      });
  }, []);

  // Hàm xử lý thanh toán
  const handlePayment = async (ownerPackageId) => {
    setLoadingId(ownerPackageId);
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
if (!user) {
    Swal.fire({
      icon: 'warning',
      title: 'Chưa đăng nhập!',
      text: 'Vui lòng đăng nhập để gửi liên hệ.',
    })
    return;
  }
      const res = await fetch(`${API_BASE_URL}/api/Payment/paymentpackageById?id=${ownerPackageId}&userId=${user.userId}`, {
        method: 'GET'
        // headers: {
        //   'Authorization': `Bearer ${token}`,
        //   'Content-Type': 'application/json'
        // }
      });

      const data = await res.json(); // ← fix ở đây

      if (res.ok && data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      } else {
        message.error('Không lấy được link thanh toán!');
      }
    } catch (err) {
      console.error(err);
      message.error('Có lỗi khi tạo thanh toán!');
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div style={{
      maxWidth: 1200,
      margin: '30px auto',
      padding: '0 12px'
    }}>
      <Title level={2} style={{ color: '#F15637', textAlign: 'center', letterSpacing: 1 }}>
        GÓI ĐĂNG KÝ CHỦ PHÒNG FITNESS
      </Title>
      <CardGrid>
        {packages.map(pkg => (
          <StyledCard
            key={pkg.ownerPackageId}
            hoverable
            cover={
              <CoverImg
                alt="fitness owner"
                src="https://www.hertssportsvillage.co.uk/news-images/2024-Jul/summer-gym-membership-offer--5581.jpg"
                style={{
                  height: 200,
                  objectFit: 'cover',
                  borderRadius: '14px 14px 0 0',
                  background: '#f5f5f5'
                }}
              />
            }
            bodyStyle={{ padding: 22, display: 'flex', flexDirection: 'column', flex: 1 }}
          >
            {pkg.isPopular && (
              <StatusTag color="gold">
                <StarFilled style={{ marginRight: 6 }} />
                Phổ biến
              </StatusTag>
            )}
            <CardHeader>
              <span style={{ fontWeight: 700, color: '#F15637', fontSize: 22 }}>
                {pkg.name}
              </span>
            </CardHeader>
            <Price>
              <DollarOutlined /> {pkg.price?.toLocaleString()} đ
            </Price>
            <div style={{ marginBottom: 10, color: '#555', fontWeight: 500 }}>
              <ClockCircleOutlined style={{ marginRight: 6 }} />
              {pkg.durationValue} {pkg.durationType}
            </div>
            <FeatureList>
              {pkg.features?.split('.').filter(f => f.trim()).map((f, idx) => (
                <li key={idx}>
                  <CheckCircleTwoTone twoToneColor={['#F15637', '#ffcc33']} />
                  {f.trim()}
                </li>
              ))}
            </FeatureList>
            <div style={{ flex: 1 }} />
            <div style={{ textAlign: 'center' }}>
              <RegisterBtn
                type="primary"
                size="large"
                loading={loadingId === pkg.ownerPackageId}
                onClick={() => handlePayment(pkg.ownerPackageId)}
              >
                Đăng ký ngay
              </RegisterBtn>
            </div>
          </StyledCard>
        ))}
      </CardGrid>
    </div>
  );
};

export default PackageList;
